import styled from "styled-components";

export const TextInputContainer = styled.div`
  display: flex;
  padding: 16px;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  gap: 24px;
  align-self: stretch;
  border-radius: var(--Radius-Radius-L, 12px);
  border: 0.5px solid var(--Border-Neutral-Default, #5C5C5C);
  background: var(--Surface-Neutral-Subtle, #FAFAFA);
  width: 100%;
  min-height: 100px;
`;

export const TextArea = styled.textarea`
  width: 100%;
  min-height: 30px;
  resize: vertical;
  font-family: Inter, sans-serif;
  font-size: 14px;
  line-height: 20px;
  color: ${(props) => props.theme?.colors?.text?.body || "#5C5C5C"};
  background: transparent;
  border: none;
  outline: none;

  &::placeholder {
    color: ${(props) => props.theme?.colors?.text?.subtitle || "#999999"};
  }
`;

export const ButtonsRow = styled.div`
  display: flex;
  width: 100%;
  justify-content: space-between;
  align-items: center;
`;

export const LeftButtonContainer = styled.div`
  display: flex;
  justify-content: flex-start;
  align-items: center;
`;

export const RightButtonContainer = styled.div`
  display: flex;
  justify-content: flex-end;
  align-items: center;
`;

